import { Action } from '@ngrx/store';

export class StocksExchangeCheckoutAction implements Action {

    public static newOrder = '[Stocks Exchange Checkout] new_order';
    public static newOrderError = '[Stocks Exchange Checkout] new_order_error';
    public static newOrderSuccess = '[Stocks Exchange Checkout] new_order_success';

    public static editOrder = '[Stocks Exchange Checkout] editOrder';
    public static editOrderError = '[Stocks Exchange Checkout] editOrderError';
    public static editOrderSuccess = '[Stocks Exchange Checkout] editOrderSuccess';

    public static newStrategy = '[Stocks Exchange Checkout] new_strategy';
    public static newStrategyError = '[Stocks Exchange Checkout] new_strategy_error';
    public static newStrategySuccess = '[Stocks Exchange Checkout] new_strategy_success';

    public static editStrategy = '[Stocks Exchange Checkout] editStrategy';
    public static editStrategyError = '[Stocks Exchange Checkout] editStrategyError';
    public static editStrategySuccess = '[Stocks Exchange Checkout] editStrategySuccess';

    public static shutDownStrategy = '[Stocks Exchange Checkout] shutDownStrategy';
    public static shutDownStrategyError = '[Stocks Exchange Checkout] shutDownStrategy_error';
    public static shutDownStrategySuccess = '[Stocks Exchange Checkout] shutDownStrategy_success';

    public static nextWorkingDays = '[Stocks Exchange Checkout] nextWorkingDays';
    public static nextWorkingDaysError = '[Stocks Exchange Checkout] nextWorkingDays_error';
    public static nextWorkingDaysSuccess = '[Stocks Exchange Checkout] nextWorkingDays_success';

    public static setStockCheckout = '[Stocks Exchange Checkout] setStockCheckout';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
